import React from "react";
import PropTypes from "prop-types";

// material
import { Typography, Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    detailHeading: {
        color: theme.palette.text.disabled,
        marginBottom: theme.spacing(0.5),
    },
    notesCard: {
        background: theme.palette.grey[100],
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        margin: theme.spacing(1, 0),
        width: "100%",
        boxSizing: "border-box",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
    },
    noteUniversity: {
        color: theme.palette.primary.main,
        fontSize: theme.spacing(1.4),
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
        overflowWrap: "anywhere",
        wordBreak: "break-word",
    },
    noteText: {
        fontSize: theme.spacing(1.5),
        fontWeight: 500,
        fontStyle: "italic",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
    },
    notesLoader: {
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        margin: theme.spacing(1, 0),
    },
    noNotes: {
        fontSize: theme.spacing(1.5),
        background: theme.palette.grey[200],
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
    },
}));

const NotesCard = ({ note }) => {
    const classes = useStyles();
    return (
        <Box className={classes.notesCard}>
            {note.universityName ? (
                <Typography className={classes.noteUniversity} variant="body2">
                    {note.universityName}
                </Typography>
            ) : null}
            <Typography className={classes.noteText} variant="body2">
                {note.text}
            </Typography>
        </Box>
    );
};

const NotesLoader = () => {
    const classes = useStyles();
    return <Skeleton className={classes.notesLoader} variant="rect" />;
};

const Preview = ({ notes }) => {
    const classes = useStyles();
    const loadingCards = [1, 2, 3, 4];
    return (
        <>
            <Box>
                <Typography className={classes.detailHeading} variant="h4">
                    Notes Provided
                </Typography>
            </Box>
            <Box maxHeight={"200px"} overflow="auto" mb={1}>
                {notes ? (
                    notes.length > 0 ? (
                        notes.map((note, index) => <NotesCard key={index} note={note} />)
                    ) : (
                        <Box m={1}>
                            <Typography className={classes.noNotes} variant="h4">
                                No Notes To Display.
                            </Typography>
                        </Box>
                    )
                ) : (
                    loadingCards.map((item) => <NotesLoader key={item} />)
                )}
            </Box>
        </>
    );
};

export default Preview;
Preview.propTypes = {
    notes: PropTypes.array.isRequired,
};

NotesCard.propTypes = {
    note: PropTypes.shape({
        text: PropTypes.string,
        universityName: PropTypes.string,
    }).isRequired,
};
